import { CorporateDataTable } from './CorporateDataTable';

export default CorporateDataTable;
export type { ICorporateDataTableProps } from './CorporateDataTable';
